// 디바운스 함수 정의: 일정 시간 동안 입력이 없을 때만 함수 실행
export const debounce = (func, delay) => {
    let timer; // 이전 타이머 ID를 저장할 변수

    // 반환된 함수는 여러 인자를 받을 수 있도록 ...args 사용
    return (...args) => {
        clearTimeout(timer); // 이전 타이머 제거 (중복 실행 방지)

        // 새로운 타이머 설정: delay 후에 func 실행
        timer = setTimeout(() => {
            // func.apply(null, args): args 배열을 개별 인자로 풀어서 func에 전달
            // 'null'은 this 컨텍스트를 명시적으로 제거 (필요 없을 때 안전하게 처리)
            func.apply(null, args);
        }, delay); // 지정된 지연 시간(ms) 후 실행
    };
};


export const showHideBodyContainer = (paramBoolean, version) => {
    // const bodyDom1 =document.querySelector('main.container');
    // const bodyDom =document.querySelector('div.c-body');
    const bodyDom = document.querySelector('div.body-dom.min-vh-100');
    if (paramBoolean) {
        bodyDom?.setAttribute('hidden', '');
        if (version === 2) {
            bodyDom?.classList.remove('d-flex');
            bodyDom?.classList.add('d-none');
            bodyDom?.querySelector('.container.flex-grow-1')?.setAttribute('hidden', '');
            document.querySelector('.gnb-container.min-vh-100')?.setAttribute('hidden', '');
        }
    }
    if (!paramBoolean) {
        bodyDom?.removeAttribute('hidden');
        if (version === 2) {
            bodyDom?.classList.add('d-flex');
            bodyDom?.classList.remove('d-none');
            bodyDom?.querySelector('.container.flex-grow-1')?.removeAttribute('hidden');
            document.querySelector('.gnb-container.min-vh-100')?.removeAttribute('hidden');
        }
    }
}

export const BTN_KEY = {
    DEFAUlT: 'default',
    INTRO: "intro",
    SPEC: "spec",
    PROJECT: "project",
    ALL: "all",
}